import { PATHS } from 'utils/paths'

export const mapUserPermissions = (
  currentPermissions: any,
  allPermissions: any
) => {
  const userPermissions: Record<string, boolean> = {}

  if (allPermissions) {
    allPermissions.forEach((permission: any) => {
      userPermissions[permission] = currentPermissions?.includes(permission)
    })
  }

  return userPermissions
}

export const isUserAuthorisedToPath = (
  pathname: string,
  userPermissions: Record<string, boolean>
) => {
  switch (pathname) {
    case PATHS.admin:
      return userPermissions.can_view_admin_panel
    case PATHS.userManagement:
      return userPermissions.can_view_admin_panel
    case PATHS.userCreate:
      return userPermissions.can_view_admin_panel
    case PATHS.userEdit:
      return userPermissions.can_view_admin_panel
    case PATHS.userView:
      return userPermissions.can_view_admin_panel
    case PATHS.aiLimitsManagement:
      return userPermissions.can_view_admin_panel
    case PATHS.aiContext:
      return (
        userPermissions.can_view_context ||
        userPermissions.can_view_context_list
      )
    case PATHS.products:
      return userPermissions.can_view_product_list
    case PATHS.productAdd:
      return userPermissions.can_create_product
    case PATHS.productEdit:
      return userPermissions.can_update_product
    case PATHS.assets:
      return userPermissions.can_view_asset_list
    case PATHS.assetsAdd:
      return userPermissions.can_create_asset
    case PATHS.assetsEdit:
      return userPermissions.can_update_asset
    case PATHS.assetsSearch:
      return userPermissions.can_view_asset_list
    case PATHS.packages:
    case PATHS.iframes:
    case PATHS.landingPagesPackages:
    case PATHS.landingPagesIframes:
      return userPermissions.can_view_package_list
    case PATHS.reviews:
      return userPermissions.can_view_review_session
    case PATHS.landingPagesAdmin:
      return userPermissions.can_use_developer_tools
    case PATHS.landingPageFonts:
      return userPermissions.can_use_developer_tools
    case PATHS.brandsManagement:
      return userPermissions.can_use_developer_tools
    default:
      if (pathname.startsWith(`${PATHS.reviews}/`)) {
        return userPermissions.can_view_review_session
      }

      return true
  }
}
